import { useCallback, useEffect, useState } from "react";
import { listPlcs } from "./workerLineApi.js";

export const PLCS_DEFAULT_PAGE_SIZE = 25;

/**
 * Fetches GET /api/backoffice/worker-line/plcs with real server-side
 * pagination/filtering - mirrors ./useSuperAgentsList.js. Refetches every
 * time `filters` changes (superAgentOrganizationId, search, status, page,
 * pageSize). `filters` must be a stable object reference (useMemo).
 */
export function usePlcsList(filters) {
  const [state, setState] = useState({ status: "loading", data: null, error: null });
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setState((previous) => ({ status: "loading", data: previous.data, error: null }));

    listPlcs(filters)
      .then((data) => {
        if (!cancelled) {
          setState({ status: "ready", data, error: null });
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setState((previous) => ({ status: "error", data: previous.data, error }));
        }
      });

    return () => {
      cancelled = true;
    };
  }, [filters, reloadToken]);

  const refetch = useCallback(() => setReloadToken((token) => token + 1), []);

  return { ...state, refetch };
}
